import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { CalendarPicker as XCalendarPicker } from '@mui/x-date-pickers/CalendarPicker';
import { jsx as _jsx } from "react/jsx-runtime";
let warnedOnce = false;

const warn = () => {
  if (!warnedOnce) {
    console.warn(['MUI: The CalendarPicker component was moved from `@mui/lab` to `@mui/x-date-pickers`.', 'The component will no longer be exported from `@mui/lab` in the first release of July 2022.', '', "You should use `import { CalendarPicker } from '@mui/x-date-pickers'`", "or `import { CalendarPicker } from '@mui/x-date-pickers/CalendarPicker'`", '', 'More information about this migration on our blog: https://mui.com/blog/lab-date-pickers-to-mui-x/.'].join('\n'));
    warnedOnce = true;
  }
};

/**
 * @ignore - do not document.
 */
const CalendarPicker = /*#__PURE__*/React.forwardRef(function DeprecatedCalendarPicker(props, ref) {
  warn();
  return /*#__PURE__*/_jsx(XCalendarPicker, _extends({
    ref: ref
  }, props));
});
export default CalendarPicker;